import { apiClient } from "../../../base/ApiClient";

const BASE_URL = "/temporary-users/";

export const getTemporaryUsers = async (params = {}) => {
  const response = await apiClient.get(BASE_URL, { params });
  return response.data;
};

export const createTemporaryUser = async (data) => {
  const response = await apiClient.post(BASE_URL, data);
  return response.data;
};

export const updateTemporaryUser = async (id, data) => {
  const response = await apiClient.put(`${BASE_URL}${id}/`, data);
  return response.data;
};

export const deleteTemporaryUser = async (id) => {
  const response = await apiClient.delete(`${BASE_URL}${id}/`);
  return response.data;
};

export const getTemporaryUser = async (id) => {
  const response = await apiClient.get(`${BASE_URL}${id}/`);
  return response.data;
};